function startTimer(duration, display) {
  var timer = duration;
  setInterval(() => {
    var minutes = parseInt(timer / 60, 10);
    var seconds = parseInt(timer % 60, 10);
    display.textContent =
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds);
    if (--timer < 0) timer = duration;
  }, 1000);
}

// Блок запуска таймера
function waitForElementToDisplay(selector, time) {
  if (document.querySelector(selector)) {
    startTimer(60 * 10, document.querySelector(selector));
  } else {
    setTimeout(() => waitForElementToDisplay(selector, time), time);
  }
}

waitForElementToDisplay(".cart__counter-counter", 500);

if (window.location.href.includes("product")) {
  var observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "characterData" ||
        (mutation.type === "childList" && mutation.addedNodes.length > 0)
      ) {
        const button = document.querySelector(
          ".m-sticky-addtocart  .m-add-to-cart--text"
        );
        /*if (button && button.textContent !== "Buy Now and Save 25%") {
          button.textContent = "Add to check out";
        }*/
      }
    });
  });
  const config = {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
  };
  const target = document.querySelector(
    ".m-sticky-addtocart  .m-add-to-cart--text"
  );
  if (target) observer.observe(target, config);
}

/*
document.addEventListener('DOMContentLoaded', (e) => {
    setTimeout(() => {
        const videos = document.querySelectorAll('.tolstoy-stories video');
        videos.forEach(video => {
            video.removeAttribute('playsinline');
        })
    }, 10000)
});
*/

function initMobileBehavior() {
    const fakeBtn = document.querySelector('.mobile__link-button');
    const toggleBtn = document.querySelector('.m-menu-mobile__toggle-button');

  try{
      fakeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        toggleBtn.click();
      });
    }  catch (error) {
    }
  }

// Проверяем разрешение экрана при первой загрузке страницы
if (window.innerWidth <= 1023) {
    initMobileBehavior();
}

// Проверяем разрешение экрана каждый раз при изменении размера окна
window.addEventListener('resize', () => {
    if (window.innerWidth <= 1023) {
        initMobileBehavior();
    }
});
document.addEventListener('DOMContentLoaded', (e) => {
  const reviewBtn = document.querySelector('.m-tab-header[data-block-type="reviews"]');
  const reviewBlock = document.querySelector('.jdgm-rev-widg[data-number-of-reviews]');
  if(reviewBlock !==null && reviewBlock.getAttribute('data-number-of-reviews') < 1) {
      reviewBtn.style.display = 'none';
  } 
  //console.log(reviewBtn);
   //console.log(reviewBlock);
})


